import { EventEmitter, Injectable } from '@angular/core';
import { IPos } from '../../interfaces/pos-search.interface';
import { DeliveryMode, PaymentMode } from '../../interfaces/paymentAndDelivery.interface';
import { FormStateChange, FormStateChangeService, StateInputFields } from '../form-state/form-state-change.service';
import { DeliveryModeEnum } from '../../models/cartDetails/deliveryModeEnum.model';

interface PosData {
  selectedPos: IPos.Marker;
  selectedPosError: boolean;
}

@Injectable()
export class DeliveryPickupService {
  public posData: PosData = {
    selectedPos: null,
    selectedPosError: false
  };
  public showSelectedPosError = false;
  private paymentModesEmitter: EventEmitter<PaymentMode[]> = new EventEmitter();
  private posPaymentModes: PaymentMode[];

  constructor(
    private formStateChangeService: FormStateChangeService
  ) {
  }

  public reloadPaymentModes(availableDeliveryModes: DeliveryMode[], deliveryModeCode?: string): void {
    const deliveryMode = availableDeliveryModes
      .find((availablePaymentMode: DeliveryMode) => availablePaymentMode.code === deliveryModeCode);

    if (deliveryModeCode && deliveryModeCode === DeliveryModeEnum.POS) {
      this.formStateChangeService.subscribe((stateChange: FormStateChange) => {
        if (stateChange.inputField === StateInputFields.POS_PAYMENT_MODES) {
          this.posPaymentModes = stateChange.value;
        }

        if (stateChange.inputField === StateInputFields.IDENTITY_CONFIRMATION_TYPE) {
          this.posPaymentModes = null;
        }
      });

      this.posPaymentModes
        ? this.paymentModesEmitter.emit(this.posPaymentModes)
        : this.paymentModesEmitter.emit(deliveryMode?.paymentModes);
    } else {
      this.paymentModesEmitter.emit(deliveryMode?.paymentModes || []);
    }
  }

  public subscribePaymentChange(callback: any): void {
    this.paymentModesEmitter.subscribe(callback);
  }

  public setPos(pos: IPos.Marker): void {
    this.posData.selectedPos = pos;
  }

  public getSelectedPos(): IPos.Marker {
    return this.posData.selectedPos;
  }

  public isPosSelected(): boolean {
    return this.posData.selectedPos !== null;
  }

  public setSelectedPosError(isError: boolean): void {
    this.posData.selectedPosError = isError;
  }

  public isSelectedPosError(): boolean {
    return this.posData.selectedPosError;
  }

  public showPosError(): boolean {
    this.setSelectedPosError(!this.isPosSelected());

    if (this.isPosSelected()) {
      this.showSelectedPosError = false;

      return false;
    } else {
      setTimeout(() => {
        const errorElement: HTMLElement = document.querySelector('#selected-pos-error');
        errorElement?.focus();
      }, 200);

      this.showSelectedPosError = true;

      return true;
    }
  }
}
